export class DesactiverEmployee {
    username:string;
    backupUsername:string;
  }